(function() {
  var WRAPPER_SELECTOR = '.product__media-wrapper.product__media-wrapper--sync[data-height-sync]';
  var HEIGHT_SYNC_ATTR = 'data-height-sync';
  var TARGET_ATTR = 'data-height-sync-target';
  var ACTIVE_CLASS = 'product__media-wrapper--synced-active';
  var RESIZE_OBSERVER_KEY = '__heightSyncResizeObserver';
  var OBSERVED_TARGET_KEY = '__heightSyncObservedTarget';
  var FALLBACK_INTERVAL_KEY = '__heightSyncFallbackInterval';
  var TARGET_CACHE_KEY = '__heightSyncTarget';
  var SCHEDULE_CACHE_KEY = '__heightSyncSchedule';
  var INITIALIZED_FLAG = '__heightSyncInitialized';
  var SCHEDULED_FLAG = '__heightSyncScheduled';
  var BASELINE_KEY = '__heightSyncBaseline';
  var TARGET_ACTIVE_CLASS = 'product__info-wrapper--synced-active';
  var MANUAL_HEIGHT_EVENT = 'tenez:manual-recommendations:height-change';
  var RECOMMENDATIONS_LOADED_EVENT = 'tenez:product-recommendations:loaded';

  var wrappers = [];
  var desktopQuery = null;

  if (typeof window.matchMedia === 'function') {
    desktopQuery = window.matchMedia('(min-width: 990px)');
  }

  function isDesktop() {
    return !desktopQuery || desktopQuery.matches;
  }

  function schedule(callback) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(callback);
    } else {
      setTimeout(callback, 16);
    }
  }

  function findTarget(wrapper) {
    if (!wrapper || !wrapper.isConnected) return null;
    var key = wrapper.getAttribute(HEIGHT_SYNC_ATTR);
    if (!key) return null;
    var root = wrapper.closest('.product');
    var selector = '[' + TARGET_ATTR + '="' + key + '"]';
    if (root) {
      return root.querySelector(selector);
    }
    return document.querySelector(selector);
  }

  function clearWrapper(wrapper) {
    if (!wrapper) return;
    wrapper.style.removeProperty('height');
    wrapper.classList.remove(ACTIVE_CLASS);
    wrapper[BASELINE_KEY] = null;

    var target = wrapper[TARGET_CACHE_KEY];
    if (!target || !target.isConnected) {
      target = findTarget(wrapper);
    }
    if (target && target.isConnected) {
      target.style.removeProperty('height');
      target.style.removeProperty('max-height');
      target.classList.remove(TARGET_ACTIVE_CLASS);
    }
  }

  function applyTargetHeight(wrapper, target) {
    if (!wrapper || !target || !target.isConnected) return;
    target.style.removeProperty('height');
    target.style.removeProperty('max-height');
    target.classList.add(TARGET_ACTIVE_CLASS);
  }

  function applyHeight(wrapper) {
    if (!wrapper) return;
    wrapper[SCHEDULED_FLAG] = false;

    if (!wrapper.isConnected) {
      clearWrapper(wrapper);
      return;
    }

    var target = wrapper[TARGET_CACHE_KEY];
    if (!target || !target.isConnected) {
      target = findTarget(wrapper);
      wrapper[TARGET_CACHE_KEY] = target;
    }

    if (!target || !target.isConnected) {
      clearWrapper(wrapper);
      return;
    }

    var resizeObserver = wrapper[RESIZE_OBSERVER_KEY];
    if (resizeObserver && typeof resizeObserver.observe === 'function') {
      var observedTarget = wrapper[OBSERVED_TARGET_KEY];
      if (observedTarget && observedTarget !== target && typeof resizeObserver.unobserve === 'function') {
        resizeObserver.unobserve(observedTarget);
      }
      if (observedTarget !== target) {
        resizeObserver.observe(target);
        wrapper[OBSERVED_TARGET_KEY] = target;
      }
    }

    if (!isDesktop()) {
      clearWrapper(wrapper);
      return;
    }

    target.style.removeProperty('height');
    target.style.removeProperty('max-height');

    var height = target.getBoundingClientRect().height;
    if (!height || height <= 0 || !isFinite(height)) {
      clearWrapper(wrapper);
      return;
    }

    var roundedHeight = Math.round(height);
    if (roundedHeight <= 0) {
      clearWrapper(wrapper);
      return;
    }

    var lockedHeight = getLockedMediaHeight(wrapper);
    if (lockedHeight && lockedHeight > roundedHeight) {
      roundedHeight = lockedHeight;
    }

    var baseline = wrapper[BASELINE_KEY];
    var shouldUpdateBaseline =
      typeof baseline !== 'number' || baseline <= 0 || (lockedHeight && lockedHeight > baseline + 1);

    if (shouldUpdateBaseline) {
      baseline = Math.max(roundedHeight, lockedHeight || 0);
      wrapper[BASELINE_KEY] = baseline;
    } else if (roundedHeight > baseline + 1) {
      roundedHeight = baseline;
    } else if (roundedHeight < baseline - 1) {
      baseline = roundedHeight;
      wrapper[BASELINE_KEY] = baseline;
    }

    var targetHeight = Math.max(roundedHeight, lockedHeight || 0);
    applyTargetHeight(wrapper, target);

    var currentHeight = parseFloat(wrapper.style.height);
    if (!isNaN(currentHeight) && Math.abs(currentHeight - targetHeight) < 1) {
      wrapper.classList.add(ACTIVE_CLASS);
      return;
    }

    wrapper.style.height = targetHeight + 'px';
    wrapper.classList.add(ACTIVE_CLASS);
  }

  function teardownWrapper(wrapper) {
    if (!wrapper) return;

    clearWrapper(wrapper);

    var resizeObserver = wrapper[RESIZE_OBSERVER_KEY];
    if (resizeObserver && typeof resizeObserver.disconnect === 'function') {
      resizeObserver.disconnect();
    }
    wrapper[RESIZE_OBSERVER_KEY] = null;
    wrapper[OBSERVED_TARGET_KEY] = null;

    var fallbackInterval = wrapper[FALLBACK_INTERVAL_KEY];
    if (fallbackInterval) {
      clearInterval(fallbackInterval);
    }
    wrapper[FALLBACK_INTERVAL_KEY] = null;

    wrapper[TARGET_CACHE_KEY] = null;
    wrapper[SCHEDULE_CACHE_KEY] = null;
    wrapper[INITIALIZED_FLAG] = false;
    wrapper[SCHEDULED_FLAG] = false;
  }

  function scheduleApply(wrapper) {
    if (!wrapper) return;

    if (wrapper[SCHEDULED_FLAG]) return;
    wrapper[SCHEDULED_FLAG] = true;

    var scheduled = wrapper[SCHEDULE_CACHE_KEY];
    if (!scheduled) {
      scheduled = function() {
        applyHeight(wrapper);
      };
      wrapper[SCHEDULE_CACHE_KEY] = function() {
        schedule(scheduled);
      };
    }
    wrapper[SCHEDULE_CACHE_KEY]();
  }

  function initWrapper(wrapper) {
    if (!wrapper || wrapper[INITIALIZED_FLAG]) return;

    wrapper[INITIALIZED_FLAG] = true;
    wrappers.push(wrapper);

    var target = findTarget(wrapper);
    if (target) {
      wrapper[TARGET_CACHE_KEY] = target;
    }

    var scheduleCallback = function() {
      scheduleApply(wrapper);
    };

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(scheduleCallback);
      if (target) {
        resizeObserver.observe(target);
        wrapper[OBSERVED_TARGET_KEY] = target;
      }
      wrapper[RESIZE_OBSERVER_KEY] = resizeObserver;
    } else {
      var runs = 0;
      var fallbackInterval = setInterval(function() {
        runs += 1;
        scheduleCallback();
        if (runs > 20) {
          clearInterval(fallbackInterval);
        }
      }, 200);
      wrapper[FALLBACK_INTERVAL_KEY] = fallbackInterval;
    }

    scheduleCallback();
    applyHeight(wrapper);
  }

  function getLockedMediaHeight(wrapper) {
    if (!wrapper || typeof window === 'undefined') return null;

    var slider = wrapper.querySelector('.product__media-list');
    if (!slider) return null;

    var paddingValue =
      slider.style.getPropertyValue('--product-first-media-padding') ||
      (window.getComputedStyle ? window.getComputedStyle(slider).getPropertyValue('--product-first-media-padding') : '');
    if (!paddingValue) return null;

    var ratioPercent = parseFloat(paddingValue);
    if (!ratioPercent || ratioPercent <= 0 || !isFinite(ratioPercent)) return null;

    var reference =
      wrapper.querySelector('.product__media-item.is-active .product-media-container') ||
      wrapper.querySelector('.product-media-container');
    var width = reference ? reference.getBoundingClientRect().width : wrapper.getBoundingClientRect().width;
    if (!width || width <= 0 || !isFinite(width)) return null;

    return Math.round((ratioPercent / 100) * width);
  }

  function filterWrappers() {
    var nextWrappers = [];
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      if (wrapper && wrapper.isConnected) {
        nextWrappers.push(wrapper);
      } else if (wrapper) {
        teardownWrapper(wrapper);
      }
    }
    wrappers = nextWrappers;
  }

  function syncAll() {
    filterWrappers();
    for (var i = 0; i < wrappers.length; i++) {
      scheduleApply(wrappers[i]);
    }
  }

  function resetBaselines() {
    filterWrappers();
    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i][BASELINE_KEY] = null;
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      initWrapper(nodes[i]);
    }
    syncAll();
  }

  function onDesktopChange() {
    schedule(initAll);
  }

  function onEvent() {
    schedule(initAll);
  }

  function onRecommendationsLoaded() {
    resetBaselines();
    schedule(initAll);
  }

  if (desktopQuery) {
    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', onDesktopChange);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(onDesktopChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onEvent, { once: true });
  } else {
    schedule(initAll);
  }

  window.addEventListener('load', onEvent);
  window.addEventListener('resize', onEvent);
  document.addEventListener('shopify:section:load', onEvent);
  document.addEventListener('shopify:section:unload', onEvent);
  document.addEventListener('shopify:block:select', onEvent);
  document.addEventListener('shopify:block:deselect', onEvent);
  document.addEventListener(MANUAL_HEIGHT_EVENT, onEvent);
  document.addEventListener(RECOMMENDATIONS_LOADED_EVENT, onRecommendationsLoaded);
})();
